import { Input } from '@chakra-ui/react';
import { TextBlock as ITextBlock } from '@/lib/types';
import BaseInputBlock from './base-input-block';
import { useFillableBlockResponse } from './common';

interface Props {
  block: ITextBlock;
}

export default function TextBlock({ block }: Props) {
  const { payload, updatePayload } = useFillableBlockResponse({ block });

  return (
    <BaseInputBlock block={block}>
      <Input
        id={`block-${block.referenceID}`}
        value={payload?.value || ''}
        placeholder={block.properties?.placeholder}
        onChange={(e) => updatePayload({ value: e.currentTarget.value })}
      />
    </BaseInputBlock>
  );
}
